<template>

  <ControlliEstrattoBanca />

</template>

<script>
import ControlliEstrattoBanca from '../components/pratiche/estratticonto/ControlliEstrattoBanca.vue'

export default {
  pageName: 'controlli-estratto-banca',
  components: {
    ControlliEstrattoBanca
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },
}
</script>
